import React from "react";

interface PageStateProps {
  eyebrow?: string;
  title: string;
  description: string;
  tone?: "default" | "error" | "loading";
  actionHref?: string;
  actionLabel?: string;
}

const PageState: React.FC<PageStateProps> = ({
  eyebrow = "Status",
  title,
  description,
  tone = "default",
  actionHref,
  actionLabel,
}) => {
  return (
    <section className={`page-state page-state-${tone} glass-panel`}>
      <span className="section-eyebrow">{eyebrow}</span>
      <h2 className="section-title">{title}</h2>
      <p className="section-description">{description}</p>
      {actionHref && actionLabel ? (
        <a href={actionHref} className="secondary-button page-state-action">
          {actionLabel}
        </a>
      ) : null}
    </section>
  );
};

export default PageState;
